var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Map, fromJS } from 'immutable';
// - Import action types
import { PostActionType } from 'constants/postActionType';
import { PostState } from './PostState';
var updatePost = function (state, payload) {
    var post = payload.post;
    var updatePostOwnerId = post.get('ownerUserId');
    var updatePostUsername = post.get('ownerUserId');
    var updatePostId = post.get('id');
    return state
        .setIn(['userPosts', updatePostOwnerId, updatePostId], Map(post));
};
var updatePostComments = function (state, payload) {
    var post = payload.post;
    var updatePostOwnerId = post.get('ownerUserId');
    var updatePostId = post.get('id');
    return state
        .setIn(['userPosts', updatePostOwnerId, updatePostId, 'comments'], post.get('comments'));
};
var updatePostVotes = function (state, payload) {
    var post = payload.post;
    var updatePostOwnerId = post.get('ownerUserId');
    var updatePostId = post.get('id');
    return state
        .setIn(['userPosts', updatePostOwnerId, updatePostId, 'votes'], post.get('votes'));
};
/**
 * Post reducer
 * @param {object} state
 * @param {object} action
 */
export var postReducer = function (state, action) {
    if (state === void 0) { state = Map(new PostState()); }
    var payload = action.payload;
    switch (action.type) {
        case PostActionType.CLEAR_ALL_DATA_POST:
            return Map(new PostState());
        case PostActionType.ADD_IMAGE_POST:
            return state
                .setIn(['userPosts', payload.uid, payload.post.id], Map(payload.post));
        case PostActionType.ADD_POST:
            return state
                .setIn(['userPosts', payload.uid, payload.post.id], fromJS(__assign({}, payload.post)));
        case PostActionType.UPDATE_POST: return updatePost(state, payload);
        case PostActionType.UPDATE_POST_COMMENTS: return updatePostComments(state, payload);
        case PostActionType.UPDATE_POST_VOTES: return updatePostVotes(state, payload);
        case PostActionType.DELETE_POST:
            return state
                .deleteIn(['userPosts', payload.uid, payload.id]);
        case PostActionType.ADD_LIST_POST:
            return state
                .mergeDeepIn(['userPosts'], payload.userPosts)
                .set('loaded', true);
        case PostActionType.ADD_FILTERED_POST:
            // console.log('the load' ,payload.type)
            // alert('here it is')
            return state
                .mergeDeepIn(['filteredPosts', "" + payload.type], payload.userPosts)
                .set('loaded', true);
        case PostActionType.CLEAR_FILTERED_STATE:
            return state
                .set('filteredPosts', Map({}));
        case PostActionType.HAS_MORE_DATA_STREAM:
            return state
                .setIn(['stream', 'hasMoreData'], true);
        case PostActionType.NOT_MORE_DATA_STREAM:
            return state
                .setIn(['stream', 'hasMoreData'], false);
        case PostActionType.REQUEST_PAGE_STREAM:
            return state
                .setIn(['stream', 'lastPageRequest'], payload.page);
        case PostActionType.LAST_POST_STREAM:
            return state
                .setIn(['stream', 'lastPostId'], payload.lastPostId);
        case PostActionType.HAS_MORE_DATA_PROFILE:
            return state
                .setIn(['profile', 'hasMoreData'], true);
        case PostActionType.NOT_MORE_DATA_PROFILE:
            return state
                .setIn(['profile', payload.userId, 'hasMoreData'], false);
        case PostActionType.REQUEST_PAGE_PROFILE:
            return state
                .setIn(['profile', payload.userId, 'lastPageRequest'], payload.page);
        case PostActionType.LAST_POST_PROFILE:
            return state
                .setIn(['profile', payload.userId, 'lastPostId'], payload.lastPostId);
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/posts/postReducer.ts
// module id = 569
// module chunks = 50